import discardTxpOption from './actions/discardTxpOption';
import saveTxpOption from './actions/saveTxpOption';
import TxpFull from './components/TxpFull';
import isTxpOptionDirty from './utils/isTxpOptionDirty';
import * as React from 'react';
/**
 * Txp options settings
 */
var TxpOption = {
    key: 'txp',
    titleStringKey: 'optionTitle_eventsForEmail',
    searchTermsStringKey: 'optionSearch_eventsForEmail',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: function () { return React.createElement(TxpFull, null); },
        isDirty: isTxpOptionDirty,
        onSave: saveTxpOption,
        onDiscard: discardTxpOption,
    },
};
export default TxpOption;
//# sourceMappingURL=TxpOption.js.map